import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppConfigService } from './app-config.service';
import { LenderListing } from '../shared/lender-listing.model';

export interface PcUrlsResponse {
success: boolean;
pc_urls: {
    [key: string]: string | null;
};
}

@Injectable({
    providedIn: 'root'
})
export class PCURLsService {
    private listingsSubject = new BehaviorSubject<LenderListing[]>([]);
    private pcurls$: Observable<PcUrlsResponse>;

    constructor(private httpClient: HttpClient, private appConfig: AppConfigService) {
        this.pcurls$ = this.listingsSubject.pipe(
            switchMap(lenders => this.httpClient.post<PcUrlsResponse>(this.appConfig.fruAPI + '/best/pcurls', { listings: lenders }))
        );
    }

    setListings(listings: LenderListing[]): void {
        this.listingsSubject.next(listings);
    }

    getPCURLs(): Observable<PcUrlsResponse> {
        return this.pcurls$;
    }
}